export default __webpack_public_path__ + "static/media/Club of Larsha.c1f307bd.jpg";